import classNames from "classnames/bind";
import React from "react";
import { Skeleton } from "../Skeleton";
import styles from "./PillToggle.module.scss";
import { PillToggleProps } from "./types";

const cx = classNames.bind(styles);

const PillToggle = ({
  name,
  label,
  value,
  count,
  variant,
  isDisabled,
  isLoading,
  isSelected,
  onChange,
  onHover,
}: PillToggleProps) => {
  const handleMouseEnter = (
    evt: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    onHover?.(true, evt);
  };

  const handleMouseLeave = (
    evt: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    onHover?.(false, evt);
  };

  return (
    <Skeleton isLoading={isLoading}>
      <div
        className={cx(
          "container",
          { isDisabled },
          variant && `container--${variant}`,
          { isSelected }
        )}
        aria-disabled={isDisabled}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <input
          type="checkbox"
          checked={isSelected}
          name={name}
          value={value}
          id={`${name}-${value}`}
          className={cx("input")}
          disabled={isDisabled}
          onChange={onChange}
        />
        <label
          htmlFor={`${name}-${value}`}
          className={cx("label", { isSelected, isDisabled })}
        >
          {label}
          {variant ? (
            <span
              className={cx(
                "indicator",
                variant && `indicator--${variant}`,
                (isSelected || count !== undefined) && "hidden",
                isDisabled && "isDisabled"
              )}
              role="presentation"
            ></span>
          ) : null}
          {count !== undefined ? (
            <span className={cx("count", variant && `count--${variant}`)}>
              {count}
            </span>
          ) : null}
        </label>
      </div>
    </Skeleton>
  );
};

PillToggle.displayName = "PillToggle";

export default PillToggle;
